import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/about.scss';
import image from '../../../img/about-photo.jpg';
import Button from '../buttons/Button';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const About = ({ className }) => {
    const [opened, setOpened] = useState(false);
    const onClickReadMore = useCallback(() => setOpened(!opened), [opened]);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.opened]: opened,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.image}>
                <img src={image} className={styles.photo} alt="Sally" />
            </div>
            <div className={styles.content}>
                <div className={styles.inner}>
                    <h4 className={styles.title}>About Sally</h4>
                    <div className={styles.text}>
                        <p>
                            Sally was an aristocrat, a dignitary’s daughter, and an Embassy brat.
                            Her father’s posting as an Ethiopian diplomat meant that the family
                            lived in various countries before settling in Canada in 1968. Selamawit
                            Dawit – Sally to her friends – went to Carleton University in Ottawa and
                            was a bright, outgoing young student with many friends and hopeful
                            suitors. In the summer of 1973, Sally traveled to Ethiopia on holiday.
                            She never came back.
                        </p>
                        <p>
                            In a few short months, Sally’s life changed drastically. She went from
                            being a party girl obsessed with clothes and perfume to a communist and
                            women’s group leader who gave speeches against the Ethiopian government.
                        </p>

                        <div className={styles.moreText}>
                            <p>
                                During her tumultuous time in the Ethiopian capital of Addis Ababa,
                                she was swept up in the Marxist movement after meeting Tselote
                                Hizkias, deputy commander and future rebel leader of the Ethiopian
                                People’s Revolutionary Party (the EPRP). Deeply in love, Sally and
                                Tselote were married in a small civil ceremony. Together, they
                                fought to overthrow Emperor Haile Selassie. In power since 1930,
                                Selassie was Ethiopia’s Head of State and a close acquaintance of
                                Sally’s father.
                            </p>

                            <p>
                                In September of 1974, the military junta (&quot;the Derg&quot;) toppled
                                Selassie in a military coup. Its leader, Mengistu Haile Mariam,
                                declared himself Chairman, ignoring the communist ideals and youth
                                movement that powered the revolution. The EPRP challenged the Derg’s
                                rule and pushed for a broad-based civilian-run democracy while also
                                engaging in campaigns against the military government. The Derg, in
                                turn, launched attacks against the EPRP, sending both the military
                                and armed peasant groups to track down hundreds of “enemies of the
                                state.” Violence soon became widespread across the country.
                            </p>

                            <p>
                                Sally and her husband hastily went underground. Together, they
                                escaped Addis Ababa and vanished into the mountains of Northern
                                Ethiopia. For years, Sally’s family searched for her throughout
                                Europe, Africa and North America. They desperately chased rumours of
                                her whereabouts, showing her photo to strangers and seeking help
                                from mystics.
                            </p>

                            <p>
                                Some forty years after the events, director Tamara Dawit pieces
                                together the mysterious journey of Sally, the aunt she never knew.
                                No one in her family had been willing to speak about this mysterious
                                relative, but after years of persistent questioning, family members
                                are starting to fill in the blanks.
                            </p>

                            <p>
                                Like most Ethiopians, the Dawits learned to stay silent about events
                                that occurred during the “Red Terror”– a bloodbath from 1977 to 1978
                                that Amnesty International has stated was responsible for the
                                slaughter of hundreds of thousands of people. The Derg remained in
                                power until 1991.
                            </p>

                            <p>
                                If time doesn’t necessarily heal such deep wounds, it at least
                                allows the fear to gradually subside. Today, in a time when Ethiopia
                                is going through important political changes once again, many
                                Ethiopians are ready to share their story. Using Sally’s personal
                                history as a thread, the film sheds light on a dark and little-known
                                chapter of Ethiopian history.
                            </p>

                            <p>
                                Finding Sally features intimate testimonials from Tamara’s
                                grandmother and aunts, a moving collection of recovered family
                                photos, a wealth of fascinating stock footage from the 60s and 70s,
                                and evocatively crafted visuals that invoke the presence of Sally
                                throughout the story. Who was Sally? How and why did she become a
                                revolutionary? Whatever the answers may be, one thing is certain –
                                Sally’s fate is deeply entwined with the fate of the countless
                                individuals who died during the Red Terror.
                            </p>
                        </div>

                        <Button onClick={onClickReadMore} className={styles.readMore}>
                            {opened ? 'Close' : 'Read more'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

About.propTypes = propTypes;
About.defaultProps = defaultProps;

export default About;
